module.exports = __webpack_public_path__ + "static/img/equup1.62afa58c.png";